import { render, staticRenderFns } from "./ComponentDetailFields.vue?vue&type=template&id=fa135b56"
import script from "./ComponentDetailFields.vue?vue&type=script&lang=js"
export * from "./ComponentDetailFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports